<template>
  <cv-side-nav-items>
    <MenuLavori v-bind:autoapertura="false"/>
    <MenuContabilita v-bind:autoapertura="false"/>
    <MenuMovimenti v-bind:autoapertura="false"/>
    <MenuDitte v-bind:autoapertura="false" />
    <MenuPosizioni v-bind:autoapertura="false" />
  </cv-side-nav-items>
</template>

<script>
import MenuLavori from "@/components/menu/MenuLavori";
import MenuContabilita from "@/components/menu/MenuContabilita";
import MenuMovimenti from "@/components/menu/MenuMovimenti";
import MenuDitte from "@/components/menu/MenuDitte";
import MenuPosizioni from "@/components/menu/MenuPosizioni";

export default {
  name: "MenuSinistra",
  components: {
    MenuMovimenti,
    MenuLavori,
    MenuContabilita,
    MenuDitte,
    MenuPosizioni
  }
}
</script>

<style scoped>

</style>